import React, { useEffect } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { appExtraFunctions } from '../../../../store/actions/AppActions';

const OrderSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const orders = useSelector(state => state?.backlist?.placedOrderInfo)?.[0];

  useEffect(() => {
    dispatch(appExtraFunctions('saveActiveStep', 0));

    if (!orders) {
      navigate('/');
    }
  }, [orders]);

  return (
    orders && (
      <div>
        <AppTitle title={'Order Successful'} from='Checkout' to='Order Confirmation' link='/' />

        <div className='container mt-8 mb-3'>
          <div className='alert alert-success' role='alert'>
            <h4 className='alert-heading'>Thank you for your order! 🎉</h4>

            {orders?.product?.category === 'Courses' ? (
              <>
                <p>
                  We are pleased to inform you that your course material purchase has been
                  successfully processed. Here are the details:
                </p>

                <div>
                  <p>
                    <b>Order Number:</b> {orders?.orderId}
                  </p>
                  <p>
                    <b>Purchase Date:</b> {moment(orders?.orderedOn).format('lll')}
                  </p>
                  <p>
                    <b>Total Amount:</b> ₹{(orders?.totalPrice).toFixed(2)}
                  </p>
                  <p>
                    <b>Email:</b> {orders?.billingAddress?.email}
                  </p>

                  <br />
                  <p>
                    The course PDF(s) will be sent to the above mentioned email shortly. Please keep
                    an eye on your inbox (and spam folder, just in case).
                  </p>
                </div>
                <hr />
                <p className='mb-0'>
                  Thank you for your purchase! We hope the material supports your learning. If you
                  need any assistance, feel free to reach out.
                </p>
              </>
            ) : (
              <>
                <p>
                  We are pleased to inform you that your order has been successfully processed. Here
                  are the details:
                </p>

                <div>
                  <p>
                    <b>Order Number:</b> {orders?.orderId}
                  </p>
                  <p>
                    <b>Order Date:</b> {moment(orders?.orderedOn).format('lll')}
                  </p>
                  <p>
                    <b>Total Amount:</b> ₹{(orders?.totalPrice).toFixed(2)}
                  </p>
                  <br />
                  <p>
                    <b>Shipping Address:</b>
                    <br />
                    {orders?.billingAddress?.address}
                    <br />
                    {orders?.billingAddress?.['Town/City']}, {orders?.billingAddress?.['state']},{' '}
                    {orders?.billingAddress?.country} - {orders?.billingAddress?.zipCode}
                  </p>
                  <p>
                    <b>Phone:</b> {orders?.billingAddress?.phone}
                  </p>
                  <p>
                    <b>Email:</b> {orders?.billingAddress?.email}
                  </p>

                  <br />
                  <p>
                    You will receive an email confirmation shortly, along with tracking information
                    once your order has shipped.
                  </p>
                </div>
                <hr />
                <p className='mb-0'>
                  Thank you for choosing us! We appreciate your business and look forward to serving
                  you again.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default OrderSuccess;
